import type { ManageableProduct } from '../../core/authorization/api';

interface Props {
  products: ManageableProduct[];
  value: string;
  /** Granted visible menus for the selected role in the selected product. */
  grantedInCurrent: number | null;
  disabled?: boolean;
  onChange: (code: string) => void;
}

/**
 * Product filter: only the products the signed-in administrator can manage
 * (`GET /authorization/manageable-products`). The selected tab shows granted/total
 * for the current role; the others show how many menus the product has.
 */
export function ProductTabs({ products, value, grantedInCurrent, disabled, onChange }: Props) {
  if (products.length === 0) return null;
  return (
    <div className="perm-products" role="tablist" aria-label="Product">
      {products.map((p) => {
        const selected = p.code === value;
        return (
          <button
            key={p.code}
            type="button"
            role="tab"
            aria-selected={selected}
            className={selected ? 'on' : ''}
            disabled={disabled}
            onClick={() => !selected && onChange(p.code)}
          >
            {p.displayName}
            <span className="n">
              {selected && grantedInCurrent !== null ? `${grantedInCurrent}/${p.managedMenuCount}` : p.managedMenuCount}
            </span>
          </button>
        );
      })}
    </div>
  );
}
